var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "all_form_block active" }, [
    _c("form", [
      _c("div", { staticClass: "block" }, [
        _c("div", { staticClass: "name_tools" }, [
          _vm._v(_vm._s(_vm.$store.getters.t("themes")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "all_form" }, [
          _c(
            "div",
            { staticClass: "color_block" },
            _vm._l(_vm.themes, function(theme, index) {
              return _c("div", { key: theme.id, staticClass: "radio_color" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.theme_id,
                      expression: "theme_id"
                    }
                  ],
                  attrs: {
                    id: "background_radio_" + index,
                    name: "background_radio",
                    type: "radio"
                  },
                  domProps: {
                    value: theme.id,
                    checked: _vm._q(_vm.theme_id, theme.id)
                  },
                  on: {
                    change: function($event) {
                      _vm.theme_id = theme.id
                    }
                  }
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "background_radio_" + index } }, [
                  _c("img", {
                    attrs: {
                      src: theme.image,
                      alt: theme.translations[0].name,
                      width: "50px"
                    }
                  })
                ])
              ])
            }),
            0
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7845c89b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7845c89b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/cv/color-tab-components/themes.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7845c89b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/cv/color-tab-components/themes.vue
// module chunks = 0